module.exports = __webpack_public_path__ + "img/menzhen1.b5961982.png";